/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_SelectionInputs */

const en_delete_selection = /** @type {(inputs: Delete_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Selection`)
};

const nl_delete_selection = /** @type {(inputs: Delete_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwijder selectie`)
};

/**
* | output |
* | --- |
* | "Delete Selection" |
*
* @param {Delete_SelectionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const delete_selection = /** @type {((inputs?: Delete_SelectionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_SelectionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_delete_selection(inputs)
	return en_delete_selection(inputs)
});